// extracted by mini-css-extract-plugin
export default {"divider":"ViewTemplate_divider__M4I2n","languageDropdown":"ViewTemplate_languageDropdown__Jq9MU"};